<template>
  <dropdown-wrapper position="bottom-end">
    <action-button class="is-rounded is-trigger" slot="trigger">
      <icon
        class="cursor-pointer"
        icon="ellipsis-v"
      />
    </action-button>
    <dropdown-item :disabled="!audit.completed_at" @click="downloadAuditReport">
      Download Audit Report
    </dropdown-item>
    <dropdown-item :disabled="!$root.can('delete_audits', app.account_id)" @click="deleteAudit">
      Delete Audit
    </dropdown-item>
  </dropdown-wrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import download from 'downloadjs'
import { downloadFile } from '@/api/common'

export default {

  methods: {
    downloadAuditReport() {
      this.downloading = true
      this.$toast.info('Downloading your audit, please wait...')
      downloadFile(`/api/audit/${this.audit.id}/report`, ({data}) => {
        this.downloading = false
        download(data, `${this.audit.environment.name}-audit-${this.audit.id}-report.pdf`, 'application/pdf')
      }, () => {
        this.$toast.error('Whoops, something went wrong')
        this.downloading = false
      })
    },
    async deleteAudit() {
      if(await this.$confirm({
        title: 'Delete Audit',
        message: 'Are you sure you want to delete this audit?',
        confirmClass: 'is-danger',
        confirmText: 'Delete Audit'
      })) {
        this.deleting = true
        this.$store.dispatch('audit/deleteAudit').then(() => {
          this.deleting = false
          this.$toast.success('Audit deleted')
          this.$router.back()
        }).catch(error => this.deleting = false)
      }
    }
  },

  computed: {
    ...mapGetters('audit', [
      'audit'
    ]),
    ...mapGetters('app', [
      'app'
    ]),
  }
}
</script>
